import React from 'react'
import PropTypes from 'prop-types'
import { FieldArray, Field } from 'formik'

import Dollars from '../../Dollars/Dollars'
import Radio from '../../Form/Radio/Radio'
import Checkbox from '../../Form/Checkbox/Checkbox'
import ModifierFieldset from '../ModifierFieldset/ModifierFieldset'

import './ModifierGroup.css'

const isDisabled = ({values = [], index, maxSelections, isSingleSelect}) => {
  if (isSingleSelect) return false
  if (values[index].selected) return false
  const curSelections = values.filter(i => i.selected)
  return curSelections.length === maxSelections
}

export const ModifierGroup = ({ modifierGroup, values }) => {
  const { name, modifiers, maxSelections, minSelections, pricingMode, guid } = modifierGroup
  const isSingleSelect = maxSelections === 1 && minSelections === 1
  const Component = isSingleSelect ? Radio : Checkbox
  const getFieldName = (guid, index) => (isSingleSelect ? `modifiers.${guid}` : `modifiers.${guid}.${index}.selected`)

  return (
    modifiers.length
      ? <ModifierFieldset label={name} rules={{minSelections, maxSelections, pricingMode}} name={`modifiers.${guid}`}>
        <FieldArray
          name={guid}
          render={() => (
            <div data-testid='modifier-group-body' styleName='modifiers'>
              {modifiers.map(({ itemGuid, price, name }, index) => (
                <Field
                  disabled={isDisabled({values: values.modifiers[guid], index, maxSelections, isSingleSelect})}
                  key={itemGuid}
                  name={getFieldName(guid, index)}
                  value={itemGuid}
                  component={Component}
                  id={itemGuid + getFieldName(guid, index)}
                  label={
                    <span>
                      <span>{name}</span>
                      {price !== 0 && (
                        <span>
                          <Dollars amount={price} />
                        </span>
                      )}
                    </span>
                  }
                />
              ))}
            </div>
          )}
        />
      </ModifierFieldset> : null
  )
}

const ModifierShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  modifiers: PropTypes.array.isRequired,
  maxSelections: PropTypes.number,
  minSelections: PropTypes.number.isRequired,
  pricingMode: PropTypes.string.isRequired,
  guid: PropTypes.string.isRequired
})

ModifierGroup.propTypes = {
  modifierGroup: ModifierShape.isRequired,
  values: PropTypes.object.isRequired
}
